import React, {useState, useEffect} from 'react';
import UploadingFilePopUp from '../UploadingFilePopUp/UploadingFilePopUp';
import ProgressBar from '../ProgressBar';

const AnimatedUploadingFilePopUp = ({
                                      show,
                                      percentsPerSec = 2,
                                      delayGrowFactor = 0.75,
                                      progressGrowSize = 10,
                                      type = 'slowing',
                                      isModal = true,
                                      message = 'עיבוד...',
                                    }) => {
  const [progress, setProgress] = useState(0);
  const [timeouts, setTimeouts] = useState([]);

  const saveTimeout = timeoutID => setTimeouts(prevState => {
    return [...prevState, timeoutID];
  });

  const clearTimeouts = () => {
    timeouts.forEach(timeoutID => clearTimeout(timeoutID));
  }

  useEffect(() => {
    if (show) {
      setProgress(0);
      uploadingProgress();
    } else {
      clearTimeouts();
    }
  }, [show]);

  const calculateInitialDelay = () => {
    switch (type) {
      case 'slowing':
        return 500;
      case 'linear':
      default:
        return 1000;
    }
  };

  const calculateNextStepDelay = delay => {
    switch (type) {
      case 'slowing':
        return delay * delayGrowFactor;
      case 'linear':
      default:
        return delay;
    }
  };

  const calculateStepSize = () => {
    switch (type) {
      case 'slowing':
        return progressGrowSize;
      case 'linear':
      default:
        return percentsPerSec;
    }
  };

  const uploadingProgress = () => {
    const stepSize = calculateStepSize();
    let delay = calculateInitialDelay();
    let fakeProgress = 0;
    let timerId = setTimeout(function request() {
      fakeProgress += stepSize;
      setProgress(fakeProgress);
      if (fakeProgress < 100) {
        delay = calculateNextStepDelay(delay);
        timerId = setTimeout(request, delay);
        saveTimeout(timerId);
      } else {
        clearTimeouts();
      }
    }, delay);
    saveTimeout(timerId);
  };

  return isModal ? (
    <UploadingFilePopUp
      showUploadingFilePopUp={show}
      progress={progress}
      message={message}
    />
  ) : (show &&
    <ProgressBar progress={progress}/>
  );
};

export default AnimatedUploadingFilePopUp;